import { trainingCourses } from '../data/trainingCourses'
import { TrainingCourse, TrainingCourseDraft } from '../types/trainingCourse'
import { normalizeCourse } from '../utils/trainingCourses'

type Listener = () => void

// Shared course list for the listing, the dashboard and the editor
class TrainingCoursesStore {
  private courses: TrainingCourse[] = [...trainingCourses]
  private listeners = new Set<Listener>()

  getAll(): TrainingCourse[] {
    return this.courses
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  private emit() {
    this.listeners.forEach((l) => l())
  }

  save(draft: TrainingCourseDraft): TrainingCourse {
    const course = normalizeCourse({
      ...draft,
      id: draft.id || `crs-${Date.now()}`,
    }) as TrainingCourse
    const exists = this.courses.some((c) => c.id === course.id)
    this.courses = exists
      ? this.courses.map((c) => {
          if (c.id === course.id) return course
          // A course that stops being "Trainante" releases its trained courses
          if (
            course.characteristic !== 'Trainante' &&
            c.leadCourseId === course.id
          ) {
            return { ...c, leadCourseId: undefined }
          }
          return c
        })
      : [...this.courses, course]
    this.emit()
    return course
  }

  importMany(drafts: TrainingCourseDraft[]) {
    const stamp = Date.now()
    this.courses = [
      ...this.courses,
      ...drafts.map((d, i) => ({ ...d, id: `crs-${stamp}-${i}` })),
    ]
    this.emit()
  }

  remove(id: string) {
    this.courses = this.courses
      .filter((c) => c.id !== id)
      .map((c) =>
        c.leadCourseId === id ? { ...c, leadCourseId: undefined } : c,
      )
    this.emit()
  }
}

export const trainingCoursesStore = new TrainingCoursesStore()
